import { isInIframe } from 'utils/isInIframe';

export function sendFromIFrame(data: unknown, targetOrigin: string = '*') {
    if (!isSSR && isInIframe()) {
        const serializeData = JSON.stringify(data);
        window.top?.postMessage(serializeData, targetOrigin);
    }
}

type MessageMap = {
    CLOSE_MODAL: Record<string, never>;
    DELETE_CLESSON: {
        cLessonId: number;
    };
    COPY_CLESSON: Record<string, never>;
};

const ORIGIN = 'plucker';

export function sendMessageFromIFrame<T extends keyof MessageMap>(
    type: T,
    payload: MessageMap[T],
    targetOrigin: string = '*'
) {
    sendFromIFrame({ type, payload, origin: ORIGIN }, targetOrigin);
}
